'use strict';

import './app/app.css';
import './app/app.js';
